const clickHandler = (evt) => {
  evt.preventDefault();

  const target = evt.target.classList.contains('show-all-filters-toggler')
    ? evt.target
    : evt.target.closest('.show-all-filters-toggler');

  const { hiddenFilters: hiddenFiltersCounter } = target.dataset;

  const filterSections = document.querySelectorAll('.filter__section');
  if (filterSections.length) {
    if (!target.classList.contains('_open')) {
      filterSections.forEach((el) => {
        el.style.display = 'block';
      });

      target.classList.add('_open');
    } else {
      filterSections.forEach((el, index) => {
        if (index > (filterSections.length - +hiddenFiltersCounter - 1)) el.style.display = 'none';
      });

      const filtersBlock = document.querySelector('.filter__body');
      if (filtersBlock) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }

      target.classList.remove('_open');
    }
  }
};

const init = () => {
  const togglerElem = document.querySelector('.show-all-filters-toggler');
  if (togglerElem && !togglerElem.classList.contains('_init')) {
    togglerElem.addEventListener('click', clickHandler);
    const filtersBlock = document.querySelector('.filter__body');
    if (filtersBlock) filtersBlock.style.height = filtersBlock.offsetHeight;

    togglerElem.classList.add('_init');
  }
};

init();
window.initSmartFilterToggler = init;
